<template>
  <div class="inner-box">
    <el-form size="small">
      <div class="content-name">
        <h2 class="dp-ib">사이트관리</h2>
        <el-form-item label-width="0px" style="float: right;">
          <el-button type="success" icon="el-icon-document-checked" @click="excelUpload">엑셀업로드</el-button>
          <el-button type="primary" icon="el-icon-search" @click="goOpen">{{ this.$i18n.messages[this.$store.state.locale].search }}</el-button>
        </el-form-item>
      </div>
    </el-form>
    <!-- 검색조건 영역 -->
    <div class="search-form">
      <el-form size="mini" label-width="80px">
        <el-row style="margin-bottom: 0px;">
          <el-col :span="4">
            <el-form-item label="고객구분">
              <el-select v-model="form.siteType">
                <el-option value=''  label="전체">==전체==</el-option>
                <el-option
                  v-for="item in combos['siteType']"
                  :key="item.key"
                  :value="item.key"
                  :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="16">
            <el-form-item label="사이트명">
              <div style="display: flex">
                <el-input type="text" v-model="form.siteNm1"></el-input>
                <el-input type="text" v-model="form.siteNm2"></el-input>
                <el-input type="text" v-model="form.siteNm3"></el-input>
              </div>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>

          <el-col :span="8">
            <el-form-item label="지역/센터">
              <el-select v-model="form.asAgentId">
                <el-option value=''  label="전체">==전체==</el-option>
                <el-option
                    v-for="item in combos['areaAgent']"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item label="방번호">
              <el-input type="text" v-model="form.cyberRommId"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item label="M/A구분">
              <el-select v-model="form.maYn">
                <el-option value=''  label="전체">==전체==</el-option>
                <el-option
                    v-for="item in combos['maYn']"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item label="유/무상">
              <el-select v-model="form.payYn">
                <el-option value=''  label="전체">==전체==</el-option>
                <el-option
                    v-for="item in combos['payYn']"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>

      </el-form>
    </div>
    <!-- GRID -->
    <div class="">
      <div class="table-b">
          <ag-grid-vue ref="grid"
                       style="padding-top: 40px; width: 100%; height: calc(48vh);"
                       class="ag-theme-alpine grid_search_height"
                       :enableRangeSelection="true"
                       :columnDefs="columnDefs"
                       :gridOptions="gridOptions"
                       :statusBar="statusBar"
                       :defaultColDef="defaultColDef"
                       :rowData="Data"
                       @grid-ready="onReadyMain"
                       @cell-clicked="onCellClickedMain"
          />
      </div>
      <tabs :tab="tab" :active-btn="active" @changeTab="changeTab"/>
      <div class="table-header" v-if="this.viewer == 'DefaultInfo'">
        <el-form style="display: grid; float: right; margin-top: 20px;" size="small">
          <el-form-item label-width="0px">
            <el-button type="info" icon="el-icon-close" @click="cancel">취소</el-button>
            <el-button type="danger" icon="el-icon-delete" @click="deleteRow">삭제</el-button>
            <el-button type="primary" icon="el-icon-document-add" @click="save">저장</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div style="display: flex" v-if="this.viewer == 'ProductInfo'">
      <!--    모델정보    -->
      <div class="table-header" style="width: 50%" >
        <el-form style="display: grid; float: right; margin-top: 20px;" size="small">
          <el-form-item label-width="0px">
            <el-button type="danger" icon="el-icon-delete" @click="deleteProduct">삭제</el-button>
            <el-button type="primary" icon="el-icon-document-add" @click="saveProduct">저장</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!--    제조번호정보    -->
      <div class="table-header" style="width: 50%">
        <el-form style="display: grid; float: right; margin-top: 20px;" size="small">
          <el-form-item label-width="0px">
            <el-button type="danger" icon="el-icon-delete" @click="deleteModel">삭제</el-button>
            <el-button type="primary" icon="el-icon-document-add" @click="saveModel">저장</el-button>
          </el-form-item>
        </el-form>
      </div>
      </div>

      <component ref="cmpTab" v-bind:is="viewer" :custParam="custParam" :selectId="selectId"/>

      <!-- s. 이게 왜 들어왔는지 모르겠음.. 이전 작업: 420608 -> 주석 by. jaykim -->
      <!-- <search-form ref="refSearchForm" :search="search" @searchChange="searchChange"  v-show="false"/> -->
      <!-- e. 이게 왜 들어왔는지 모르겠음.. 이전 작업: 420608 -> 주석 by. jaykim -->
    </div>
  </div>

</template>

<script>
import _ from 'lodash';
import common from '@/mixin/common';
import mixinSlip from '@/mixin/slip';
import DefaultInfo from '@/components/InfoManage/SiteInfo/DefaultInfo.vue';
import ProductInfo from '@/components/InfoManage/SiteInfo/ProductInfo.vue';
import tabs from "@/components/AS/Tabs";
import SiteUploadExcel from "@/components/InfoManage/SiteInfo/SiteUploadExcel";

export default {
  name:'pExpense',
  mixins: [common, mixinSlip],
  components: {
    tabs,
    DefaultInfo,
    ProductInfo
  },
  data() {
    return {
      title: "",
      deleteid: "",
      deleteList: [],
      parentNm: "",
      rowData: [],
      viewer: 'DefaultInfo',
      tab:[
        {tabId: 'DefaultInfo', tabName:'기본정보', tabCss:"btn btn-primary", tabNo:'0'},
        {tabId: 'ProductInfo', tabName:'제품정보', tabCss:"btn btn-outline-primary", tabNo:'1'},
      ],
      active: true,
      custParam:{},
      combos: {
        'siteType' : [],         //고객구분
        'AreaAgent' : [],        //지역구분
        'maYn' : [],             //M/A구분
        'payYn' : [],            //유/무상
      },
      Data:[],
      form: {
        addr1 : "",
        addr2 : "",
        area : "",
        area_nm : "",
        asAgentId : "",
        asAgentNm : "",
        chargeNm : "",
        companyId : "",
        createDt : "",
        creatorId : "",
        creatorNm : "",
        cyberRommId : "",
        deleteYn : "",
        hpNo : "",
        maYn : "",
        modelNm : "",
        payYn : "",
        siteCd : "",
        siteId : "",
        siteNm1 : "",
        siteNm2 : "",
        siteNm3 : "",
        siteType : "",
        telNo : "",
        updateDt : "",
        updatorId : "",
        updatorNm : "",
        zipCd : "",
      },
      defForm: {
        addr1 : "",
        addr2 : "",
        area : "",
        area_nm : "",
        asAgentId : "",
        asAgentNm : "",
        chargeNm : "",
        companyId : "",
        createDt : "",
        creatorId : "",
        creatorNm : "",
        cyberRoomId : "",
        deleteYn : "",
        hpNo : "",
        maYn : "",
        modelNm : "",
        payYn : "",
        siteCd : "",
        siteId : "",
        siteNm1 : "",
        siteNm2 : "",
        siteNm3 : "",
        siteType : "",
        telNo : "",
        updateDt : "",
        updatorId : "",
        updatorNm : "",
        zipCd : "",
      },
      defFormProduct:{
        companyId:"",
        createDt:"",
        creatorId:"",
        creatorNm:"",
        deleteYn:"",
        guaranteeEndDt:"",
        guaranteeStartDt:"",
        maker:"",
        makerNm:"",
        modelCd:"",
        modelGroup:"",
        modelGroupNm:"",
        modelId:"",
        modelNm:"",
        serialNo:"",
        setupDt:"",
        siteId:"",
        siteModelId:"",
        siteModelInfoId:"",
        siteNm1:"",
        siteNm2:"",
        siteNm3:"",
        standardModelNm:"",
        updateDt:"",
        updatorId:"",
        updatorNm:"",
      },
      data: [],
      subData: [],
      gridOptions: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
      },
      gridOptionsSub: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
      },
      defaultColDef: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
      },
      defaultColDefSub: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
        //cellStyle : {'justify-content': 'center','align-items': 'center', 'display': 'flex','height': '100%'}
      },
      groupDetail: [],
      gridApi: null,
      columnApi: null,
      columnDefs: [],
      gridApiSub: null,
      columnApiSub: null,
      columnDefsSub: [],
      frameworkComponents: null,
      autoGroupColumnDef: null,
      rowModelType: null,
      isServerSideGroupOpenByDefault: null,
      isServerSideGroup: null,
      getServerSideGroupKey: null,
      selectId : "",
    };
  },
  created() {

    this.init();

    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  methods: {
    changeTab(params) {
      // const voRow = this.gridApi.getSelectedRows() //선택된 Row
      const voRow = this.rowData;

      if(voRow == '') {
        this.$swal({type: 'warning', text: '사이트를 선택해주세요.'});
        this.tab[0].tabCss = 'btn btn-primary';
        this.tab[1].tabCss = 'btn btn-outline-primary';
        this.gridApi.applyTransaction({ remove: voRow }) // 선택된 row 해제
        return false;
      }

      this.viewer = params.tabId;
      if(this.viewer == 'ProductInfo'){
        this.ProductInfo(voRow);
      }else{
        this.defaultInfo(voRow);
      }
    },
    defaultInfo(row){

      this.$http
          .post("/api/siteMng/detail", {
            companyId: this.$store.state.loginInfo.compCd,
            siteId: row.siteId,
            processTime : ""
          })
          .then(response => {
            this.custParam = response.data[0];
          }).finally(() => {
        this.$store.commit('finish')
      });

    },
    ProductInfo(row){

      // this.$store.commit('loading')
      this.$http
          .post("/api/siteMng/item", {
            companyId: this.$store.state.loginInfo.compCd,
            siteId: row.siteId,
            sortType: "",
            processTime: ""
          })
          .then(response => {
            this.custParam = response.data;
            this.$refs.cmpTab.subData = []; // 제조번호정보 초기화
            this.$refs.cmpTab.form = _.clone(this.defFormProduct);
            this.$refs.cmpTab.form2 = _.clone(this.defFormProduct);
          }).finally(() => {
        this.$store.commit('finish')
      });

    },
    //메인그리드 Ready
    onReadyMain(params) {
      //메인그리드 api 정의
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      // this.autoSizeAll(this.columnApi);


      this.$store.commit('loading')
      this.$http
          .post("/api/siteMng/list", {
            companyId: this.$store.state.loginInfo.compCd,
            siteType: "",
            siteNm1: "",
            siteNm2: "",
            siteNm3: "",
            maYn: "",
            payYn: "",
            cyberRoomId: "",
            catId : 0,
            sortType : '',
            page : 1,
            totalPage : 200,
            totalCount : 1,
            curPage : 1,
            processTime : ""
          })
          .then(response => {
            this.Data = response.data;
          }).finally(() => {
        this.$store.commit('finish')
      });
    },
    //서브그리드 Ready
    onReadySub(params) {
      //서브그리드 api 정의
      this.gridApiSub = this.gridOptionsSub.api;
      this.columnApiSub = this.gridOptionsSub.columnApi;

      this.autoSizeAll(this.columnApiSub);
    },
    //그리드컬럼 정의
    createColumnDefs() {
      const vm = this

      this.columnDefs = [
        {headerName:'고객구분', field:'siteType', width:80, editable:false,
          valueFormatter: (params) => {
            return vm.chkType(params);
          }
        },
        {headerName:'사이트ID', field:'siteId',  width:50, editable:false},
        {
          headerName: '사이트명', children: [
            {headerName: '사이트1', field: 'siteNm1', width: 50, editable: false},
            {headerName: '사이트2', field: 'siteNm2', width: 50, editable: false},
            {headerName: '사이트3', field: 'siteNm3', width: 50, editable: false},
          ], width: 150, editable: false
        },
        {headerName:'주소', field:'addr1', width:50, editable:false},
        {headerName:'담당자', field:'chargeNm', width:50, editable:false},
        {headerName:'전화번호', field:'hpNo', width:50, editable:false},
        {headerName:'방번호', field:'cyberRoomId', width:50, editable:false},
        {headerName:'센터명', field:'asAgentNm', width:50, editable:false},
        {headerName:'M/A구분', field:'maYn', width:50, editable:false},
        {headerName:'유/무상', field:'payYn', width:50, editable:false},
        ];


    },
    autoSizeAll(columnApi) {
      const allColumnIds = [];
      columnApi.columnController.gridColumns.forEach((column) => {
        allColumnIds.push(column.getId());
      });
      columnApi.columnController.autoSizeColumns(allColumnIds, false);
    },
    //Main 그리드 SelctionChange 발생
    onCellClickedMain(params) {
      const voRow = params.data //선택된 Row
      this.rowData = voRow;
      this.selectId = voRow.siteId;
      if(this.viewer == 'ProductInfo'){
        this.ProductInfo(voRow);
      }else{
        this.defaultInfo(voRow);
      }

    },
    searchChange(param){
      let vOnlySearch = _.cloneDeep(param);

      delete vOnlySearch.asAgentId;
      delete vOnlySearch.asAgentNm;
      delete vOnlySearch.areaAgent;
      delete vOnlySearch.userId;
      delete vOnlySearch.userNm;


      if(param && param.asAgentId){
        this.form.areaAgent = param.areaAgent;  /** 지역ID */
        this.form.asAgentId = param.asAgentId;  /** 처리센터 ID */
        this.form.asAgentNm = param.asAgentNm;  /** 처리센터 */
        this.form.userId = param.userId;  /** 처리기사 */
        this.form.userNm = param.userNm;  /** 처리기사 */
      }

    },
    excelUpload(){
      /** 엑셀업로드 */
      let vm = this;
      this.$modal.open({
        width: 800,
        component: SiteUploadExcel,
        parent: this,
        props: {
          data: {

          },
        },
        events: {
          close(param) {
            vm.form.maker = param.data.maker /** 제조사 */
            vm.form.makerNm = param.data.makerNm /** 제조사명 */
            vm.form.modelGroupNm = param.data.modelGroupNm /** 모델그룹명 */
            vm.form.modelGroup = param.data.modelGroup /** 모델그룹 */
            vm.form.standardModelNm = param.data.standardModelNm /** 표준모델 */
            vm.form.modelNm = param.data.modelNm /** 모델명 */
            vm.form.modelId = param.data.modelId /** 모델ID */
            vm.goOpen();
            vm.tempData = [];
          },
        }
      });

    },
    goOpen() {

      this.$store.commit('loading')
      this.$http
          .post("/api/siteMng/list", {
            companyId: this.$store.state.loginInfo.compCd,
            siteType: this.form.siteType,
            siteNm1: this.form.siteNm1,
            siteNm2: this.form.siteNm2,
            siteNm3: this.form.siteNm3,
            maYn: this.form.maYn,
            payYn: this.form.payYn,
            cyberRoomId: this.form.cyberRommId,
            catId : 0,
            sortType : '',
            page : 1,
            totalPage : 999999,
            totalCount : 1,
            curPage : 1,
            processTime : ""
          })
          .then(response => {
            this.Data = response.data;
          }).finally(() => {
        this.$store.commit('finish')
      });

    },
    save() {
      const siteInfo = JSON.parse(JSON.stringify(this.$refs.cmpTab.form));

      if(siteInfo.siteType == ""){
        this.$swal({type: 'warning', text: '고객구분을 선택해 주십시오.'});
        return false;
      }else if(siteInfo.asAgentId == ""){
        this.$swal({type: 'warning', text: '센터를 선택해 주십시오.'});
        return false;
      }else if(siteInfo.siteNm1 == ""){
        this.$swal({type: 'warning', text: '사이트명을 입력해 주십시오.'});
        return false;
      }else if(siteInfo.zipCd == ""){
        this.$swal({type: 'warning', text: '우편번호를 입력해 주십시오.'});
        return false;
      }else if(siteInfo.addr1 == ""){
        this.$swal({type: 'warning', text: '주소를 입력해 주십시오.'});
        return false;
      }else if(siteInfo.addr2 == ""){
        this.$swal({type: 'warning', text: '상세주소를 입력해 주십시오.'});
        return false;
      }else if(siteInfo.chargeNm == ""){
        this.$swal({type: 'warning', text: '고객명을 입력해 주십시오.'});
        return false;
      }else if(siteInfo.telNo == ""){
        this.$swal({type: 'warning', text: '전화번호를 입력해 주십시오.'});
        return false;
      }else if(siteInfo.maYn == ""){
        this.$swal({type: 'warning', text: 'MA구분을 선택해 주십시오.'});
        return false;
      }else if(siteInfo.payYn == ""){
        this.$swal({type: 'warning', text: '유/무상구분을 선택해 주십시오.'});
        return false;
      }

      // 비어있다면 생성 , 비어있지 않다면 수정
      if(siteInfo.siteId == ""){
        let maxIdx = 0;

        //저장 시작
        this.$http
            .put('/api/siteMng/save',{
              companyId: this.$store.state.loginInfo.compCd,
              siteType : siteInfo.siteType,
              siteCd : siteInfo.siteCd,
              asAgentId : siteInfo.asAgentId,
              siteNm1 : siteInfo.siteNm1,
              siteNm2 : siteInfo.siteNm2,
              siteNm3 : siteInfo.siteNm3,
              zipCd : siteInfo.zipCd,
              addr1 : siteInfo.addr1,
              addr2 : siteInfo.addr2,
              chargeNm : siteInfo.chargeNm,
              telNo : siteInfo.telNo,
              hpNo : siteInfo.hpNo,
              maYn : siteInfo.maYn,
              payYn : siteInfo.payYn,
              cyberRoomId : siteInfo.cyberRoomId,
              creatorId: this.$store.state.loginInfo.id
            })
            .then(response => {
              this.$swal({ type: 'success', text: '저장되었습니다.' });
              this.goOpen();
            })
            .catch(({ message }) => {
              if (message === "Request failed with status code 500") {
                this.$swal({ type: "error", text: "오류가 발생했습니다." });
              }
            });
      }else{
        //수정 시작

        this.$http
            .put('/api/siteMng/update',{
              companyId: this.$store.state.loginInfo.compCd,
              siteId : siteInfo.siteId,
              siteType : siteInfo.siteType,
              siteCd : siteInfo.siteCd,
              asAgentId : siteInfo.asAgentId,
              siteNm1 : siteInfo.siteNm1,
              siteNm2 : siteInfo.siteNm2,
              siteNm3 : siteInfo.siteNm3,
              zipCd : siteInfo.zipCd,
              addr1 : siteInfo.addr1,
              addr2 : siteInfo.addr2,
              chargeNm : siteInfo.chargeNm,
              telNo : siteInfo.telNo,
              hpNo : siteInfo.hpNo,
              maYn : siteInfo.maYn,
              payYn : siteInfo.payYn,
              cyberRoomId : siteInfo.cyberRoomId,
              updatorId: this.$store.state.loginInfo.id,
              processTime : "",
            })
            .then(response => {
              this.$swal({ type: 'success', text: '저장되었습니다.' });
              this.goOpen();
            })
            .catch(({ message }) => {
              if (message === "Request failed with status code 500") {
                this.$swal({ type: "error", text: "오류가 발생했습니다." });
              }
            });
      }

    },
    saveProduct(){
      const productInfo = JSON.parse(JSON.stringify(this.$refs.cmpTab.form));
      const voRow = this.gridApi.getSelectedRows() //선택된 Row

      if(siteInfo.modelNm == ""){
        this.$swal({type: 'warning', text: '모델을 선택해 주세요.'});
        return false;
      }else if(siteInfo.asAgentId == ""){
        this.$swal({type: 'modelQty', text: '모델수량을 입력해 주십시오.'});
        return false;
      }

      // 비어있다면 생성 , 비어있지 않다면 수정
      if(productInfo.siteModelInfoId == ""){ // 생성

        //저장 시작
        this.$http
            .put('/api/siteMng/item/save',{
              companyId: this.$store.state.loginInfo.compCd,
              siteId: this.selectId,
              modelId: productInfo.modelId,
              modelQty: productInfo.modelQty,
              creatorId: this.$store.state.loginInfo.id,
              processTime: "",
              siteModelInfoId: 0,
            })
            .then(response => {
              this.$swal({ type: 'success', text: '저장되었습니다.' });
              this.ProductInfo(voRow);
              this.$refs.cmpTab.form = _.clone(this.defFormProduct);
            })
            .catch(({ message }) => {
              if (message === "Request failed with status code 500") {
                this.$swal({ type: "error", text: "오류가 발생했습니다." });
              }
            });

      }else{ // 수정

        //수정 시작
        this.$http
            .put('/api/siteMng/item/update',{
              companyId: this.$store.state.loginInfo.compCd,
              siteId: this.selectId,
              siteModelInfoId: productInfo.siteModelInfoId,
              modelId: productInfo.modelId,
              modelQty: productInfo.modelQty,
              updatorId: this.$store.state.loginInfo.id,
              processTime: "",
            })
            .then(response => {
              this.$swal({ type: 'success', text: '저장되었습니다.' });
              this.ProductInfo(voRow);
              this.$refs.cmpTab.form = _.clone(this.defFormProduct);
            })
            .catch(({ message }) => {
              if (message === "Request failed with status code 500") {
                this.$swal({ type: "error", text: "오류가 발생했습니다." });
              }
            });

      }
    },
    saveModel(){
      const productInfo = JSON.parse(JSON.stringify(this.$refs.cmpTab.form));
      const modelInfo = JSON.parse(JSON.stringify(this.$refs.cmpTab.form2));
      const voPrdRow = this.$refs.cmpTab.gridApi.getSelectedRows() //선택된 Row
      const modelQtyLength = this.$refs.cmpTab.subData.length;

      // 비어있다면 생성 , 비어있지 않다면 수정
      if(modelInfo.siteModelId == ""){ // 생성

        if(voPrdRow[0].modelQty >= modelQtyLength) {
          this.$swal({ type: 'warning', text: '설정된 모델수량을 초과할 수 없습니다.' });
          return false;
        }

        //저장 시작
        this.$http
            .put('/api/siteMng/model/save',{
              companyId: this.$store.state.loginInfo.compCd,
              siteId: this.selectId,
              siteModelInfoId:productInfo.siteModelInfoId,
              modelId:productInfo.modelId,
              serialNo:modelInfo.serialNo,
              setupDt:modelInfo.setupDt,
              guaranteeStartDt:modelInfo.guaranteeStartDt,
              guaranteeEndDt:modelInfo.guaranteeEndDt,
              siteModelId:0,
              creatorId: this.$store.state.loginInfo.id,
              processTime: "",
            })
            .then(response => {
              this.$swal({ type: 'success', text: '저장되었습니다.' });
              this.$refs.cmpTab.modelList(voPrdRow[0].siteModelInfoId);
              this.$refs.cmpTab.form2 = _.clone(this.defFormProduct);
            })
            .catch(({ message }) => {
              if (message === "Request failed with status code 500") {
                this.$swal({ type: "error", text: "오류가 발생했습니다." });
              }
            });

      }else{ // 수정

        //수정 시작
        this.$http
            .put('/api/siteMng/model/update',{
              companyId: this.$store.state.loginInfo.compCd,
              siteId: this.selectId,
              siteModelInfoId:productInfo.siteModelInfoId,
              modelId:productInfo.modelId,
              serialNo:modelInfo.serialNo,
              setupDt:modelInfo.setupDt,
              guaranteeStartDt:modelInfo.guaranteeStartDt,
              guaranteeEndDt:modelInfo.guaranteeEndDt,
              siteModelId:modelInfo.siteModelId,
              updatorId: this.$store.state.loginInfo.id,
              processTime: "",
            })
            .then(response => {
              this.$swal({ type: 'success', text: '저장되었습니다.' });
              this.ProductInfo(voPrdRow);
              this.$refs.cmpTab.form = _.clone(this.defFormProduct);
            })
            .catch(({ message }) => {
              if (message === "Request failed with status code 500") {
                this.$swal({ type: "error", text: "오류가 발생했습니다." });
              }
            });

      }
    },
    chkType(params) {
      this.combos['siteType'].forEach(x =>{
        if(params.value === x.key) params.value = x.value;
      })
      return params.value;
    },
    deleteRow() {
      const siteInfo = JSON.parse(JSON.stringify(this.$refs.cmpTab.form));

      if(siteInfo.siteId == "") {
        this.$swal({ type: 'warning', text: '삭제 할 사이트를 선택해주세요.' });
        return false;
      }

      this.$swal({
        type: 'info',
        text: `사이트를 삭제하시겠습니까?`,
        showCancelButton: true,
        confirmButtonText: '예',
        cancelButtonText: '아니오',
      }).then((result) => {
        if (result.value) {
          this.$http
              .put('/api/siteMng/delete', {
                companyId: this.$store.state.loginInfo.compCd,
                siteId: siteInfo.siteId,
                updatorId: this.$store.state.loginInfo.id,
                processTime: "",
              })
              .then(response => {
                this.$swal({type: 'success', text: '삭제되었습니다.'});
                this.cancel();
                this.goOpen();
              })
              .catch(({message}) => {
                if (message === "Request failed with status code 500") {
                  this.$swal({type: "error", text: "오류가 발생했습니다."});
                }
              });
        }
      });
    },

    deleteProduct() {
      const productInfo = JSON.parse(JSON.stringify(this.$refs.cmpTab.form));
      const voRow = this.gridApi.getSelectedRows() //선택된 Row

      if(productInfo.siteModelInfoId == "") {
        this.$swal({ type: 'warning', text: '삭제 할 모델정보를 선택해주세요.' });
        return false;
      }

      this.$swal({
        type: 'info',
        text: `모델정보를 삭제하시겠습니까?`,
        showCancelButton: true,
        confirmButtonText: '예',
        cancelButtonText: '아니오',
      }).then((result) => {
        if (result.value) {
          this.$http
              .put('/api/siteMng/item/delete', {
                companyId: this.$store.state.loginInfo.compCd,
                siteId: productInfo.siteId,
                siteModelInfoId : productInfo.siteModelInfoId,
                updatorId: this.$store.state.loginInfo.id,
                processTime: "",
              })
              .then(response => {
                this.$swal({type: 'success', text: '삭제되었습니다.'});
                this.ProductInfo(voRow);
                this.$refs.cmpTab.form = _.clone(this.defFormProduct);
              })
              .catch(({message}) => {
                if (message === "Request failed with status code 500") {
                  this.$swal({type: "error", text: "오류가 발생했습니다."});
                }
              });
        }
      });
    },

    deleteModel() {
      const modelInfo = JSON.parse(JSON.stringify(this.$refs.cmpTab.form2));
      const selectProductId = this.$refs.cmpTab.selectProductId //선택된 Row

      if(modelInfo.siteModelInfoId == "") {
        this.$swal({ type: 'warning', text: '삭제 할 제조번호를 선택해주세요.' });
        return false;
      }

      this.$swal({
        type: 'info',
        text: `제조번호를 삭제하시겠습니까?`,
        showCancelButton: true,
        confirmButtonText: '예',
        cancelButtonText: '아니오',
      }).then((result) => {
        if (result.value) {
          this.$http
              .put('/api/siteMng/model/delete', {
                companyId: this.$store.state.loginInfo.compCd,
                siteId: modelInfo.siteId,
                siteModelInfoId : modelInfo.siteModelInfoId,
                siteModelId: modelInfo.siteModelId,
                updatorId: this.$store.state.loginInfo.id,
                processTime: "",
              })
              .then(response => {
                this.$swal({type: 'success', text: '삭제되었습니다.'});
                this.$refs.cmpTab.modelList(selectProductId);
                this.$refs.cmpTab.form2 = _.clone(this.defFormProduct);
              })
              .catch(({message}) => {
                if (message === "Request failed with status code 500") {
                  this.$swal({type: "error", text: "오류가 발생했습니다."});
                }
              });
        }
      });
    },


    cancel(){
      // form 초기화
      this.$refs.cmpTab.form = _.clone(this.defForm);
      this.rowData = [];
    },
    async init() {
      await this.$http.post(`/api/siteMng/init`,{
        parentId: '',
          })
          .then(response => {
            this.combos['siteType'] = response.data.siteType;        //고객구분
            this.combos['areaAgent'] = response.data.areaAgent;      //센터구분
            this.combos['maYn'] = response.data.maYn;                //M/A구분
            this.combos['payYn'] = response.data.payYn;              //유/무상
          }).finally(() => {

          });
      this.createColumnDefs();
    },
  },
  beforeMount() {

    this.createColumnDefs(); //그리드 컬럼정의 함수 호출

  },
  watch: {

  },
}
</script>